import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "metricsSelectorContainer" }
const _hoisted_2 = { class: "selectorPanel" }
const _hoisted_3 = { class: "category" }
const _hoisted_4 = {
  key: 0,
  class: "metric"
}
const _hoisted_5 = { class: "metric" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "metricContainer",
  style: {"margin-bottom":"10px"}
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 1,
  class: "metricContainer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_value_slider = _resolveComponent("value-slider")!
  const _component_flag_label = _resolveComponent("flag-label")!
  const _component_cross_icon = _resolveComponent("cross-icon")!
  const _component_plus_icon = _resolveComponent("plus-icon")!
  const _component_loading_icon = _resolveComponent("loading-icon")!
  const _component_check_icon = _resolveComponent("check-icon")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metricsByCategory, (metricsWithValues, category) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "categoryAndMetricsContainer",
          key: category
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(category), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(metricsWithValues, (metricWithValue) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "metricContainer",
              key: metricWithValue.filter.metric.id
            }, [
              (metricWithValue.filter.metric.type === 'value')
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(metricWithValue.filter.metric.name), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                (metricWithValue.filter.metric.type === 'value')
                  ? (_openBlock(), _createBlock(_component_value_slider, {
                      key: 0,
                      modelValue: metricWithValue.filter.filterValues,
                      "onUpdate:modelValue": [($event: any) => ((metricWithValue.filter.filterValues) = $event), ($event: any) => (_ctx.selectMetric(metricWithValue))],
                      color: metricWithValue.selected ? metricWithValue.filter.metric.color : 'grey',
                      active: "",
                      range: metricWithValue.range,
                      hideDiscardButton: "",
                      hideLabel: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "color", "range"]))
                  : (_openBlock(), _createBlock(_component_flag_label, {
                      key: 1,
                      label: metricWithValue.filter.metric.name,
                      color: metricWithValue.selected ? metricWithValue.filter.metric.color : 'grey',
                      fontColor: metricWithValue.selected ? 'black' : 'white',
                      active: "",
                      hideDiscardButton: ""
                    }, null, 8, ["label", "color", "fontColor"]))
              ]),
              _createElementVNode("button", {
                class: "metric",
                onClick: ($event: any) => (_ctx.editMetric(metricWithValue)),
                title: "Select Metric"
              }, [
                (metricWithValue.selected)
                  ? (_openBlock(), _createBlock(_component_cross_icon, {
                      key: 0,
                      height: "28",
                      width: "28"
                    }))
                  : (_openBlock(), _createBlock(_component_plus_icon, {
                      key: 1,
                      height: "28",
                      width: "28"
                    }))
              ], 8, _hoisted_6)
            ]))
          }), 128))
        ]))
      }), 128)),
      (_ctx.allowNewMetric)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newMetric.name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.newMetric.name]
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newMetric.category) = $event))
            }, null, 512), [
              [_vModelText, _ctx.newMetric.category]
            ]),
            _createElementVNode("button", {
              class: "metricType",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleNewMetricType && _ctx.toggleNewMetricType(...args))),
              title: "Switch Metric Type"
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.newMetric.type), 1)
            ]),
            _createElementVNode("button", {
              class: "metric",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addNewMetric && _ctx.addNewMetric(...args))),
              disabled: _ctx.newMetric.name === 'New Metric',
              title: "Add New Metric"
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_loading_icon, {
                    key: 0,
                    height: "28",
                    width: "28"
                  }))
                : (_openBlock(), _createBlock(_component_check_icon, {
                    key: 1,
                    height: "28",
                    width: "28"
                  }))
            ], 8, _hoisted_8)
          ]))
        : (_ctx.metrics.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[4] || (_cache[4] = [
              _createElementVNode("span", { class: "emptySearch" }, "No metrics found", -1)
            ])))
          : _createCommentVNode("", true)
    ])), [
      [_directive_click_outside, _ctx.clickOutside]
    ])
  ]))
}